"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdentifierType = exports.OtpConsentType = exports.JwtConsentType = exports.WogConsentType = exports.AuthType = exports.NDIConsentType = void 0;
var NDIConsentType;
(function (NDIConsentType) {
    NDIConsentType["BASIC"] = "BASIC";
    NDIConsentType["FULL"] = "FULL";
    NDIConsentType["CORPPASS"] = "CORPPASS";
})(NDIConsentType || (exports.NDIConsentType = NDIConsentType = {}));
var AuthType;
(function (AuthType) {
    AuthType["NONE"] = "NONE";
    AuthType["SINGPASS"] = "SINGPASS";
    AuthType["CORPPASS"] = "CORPPASS";
    AuthType["GUEST"] = "GUEST";
    AuthType["GUEST_ENHANCED"] = "GUEST_ENHANCED";
    AuthType["MOBILE_OTP"] = "MOBILE_OTP";
    AuthType["WOGAAD"] = "WOGAAD";
    AuthType["COGNITO"] = "COGNITO";
    AuthType["SSO"] = "SSO";
})(AuthType || (exports.AuthType = AuthType = {}));
var WogConsentType;
(function (WogConsentType) {
    WogConsentType["WOG_AAD"] = "WOG_AAD";
})(WogConsentType || (exports.WogConsentType = WogConsentType = {}));
var JwtConsentType;
(function (JwtConsentType) {
    JwtConsentType["CCUBE_DEMO"] = "CCUBE_DEMO";
    JwtConsentType["WORKPAL_MOBILE"] = "WORKPAL_MOBILE";
    JwtConsentType["SGW"] = "SGW";
})(JwtConsentType || (exports.JwtConsentType = JwtConsentType = {}));
var OtpConsentType;
(function (OtpConsentType) {
    OtpConsentType["WOG_USER_OTP"] = "WOG_USER_OTP";
})(OtpConsentType || (exports.OtpConsentType = OtpConsentType = {}));
var UserIdentifierType;
(function (UserIdentifierType) {
    UserIdentifierType["WOG_USER"] = "wog-user-id";
    UserIdentifierType["MOL_USER"] = "mol-user-id";
    UserIdentifierType["AGENCY_APP"] = "agency-app-id";
})(UserIdentifierType || (exports.UserIdentifierType = UserIdentifierType = {}));
//# sourceMappingURL=enums.js.map